import { Link } from "react-router-dom";
import { SecretaryLayout } from "../Layout";
import { DoctorsTable } from "../components";

export const DoctorsPage = () => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <SecretaryLayout>
      <div className="container-fluid">
        <div className="layout-specing">
          <div className="row">
            <div className="col-xl-9 col-md-6">
              <h5 className="mb-0">Doctores</h5>

              <nav aria-label="breadcrumb" className="d-inline-block mt-2">
                <ul className="breadcrumb breadcrumb-muted bg-transparent rounded mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/secretary/dashboard">gosafe</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Doctores
                  </li>
                </ul>
              </nav>
            </div>

            <div className="col-xl-3 col-md-6 mt-4 mt-md-0 text-md-end">
              <Link to="/secretary/add-doctor" className="btn btn-primary">
                Agregar nuevo doctor
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-12 mt-4">
              <DoctorsTable />
            </div>
          </div>
        </div>
      </div>
    </SecretaryLayout>
  );
};
